export default __webpack_public_path__ + "static/media/login_banner.2101deb7.svg";